// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5999":"9934a8c1","9019":"9934a8c1"}[chunkId] + ".chunk.css";
};